module.exports = __webpack_public_path__ + "static/media/operationshead.f9424368.jpg";